module.exports = require("npm:async.util.isarraylike@0.5.2/index.js");